import moment from "moment-timezone";

/**
 * 쿠키 유틸리티
 *
 * [사용법]
 *      const cookie = new CookieUtil();
 *
 *      const expires = '1Y';
 *      cookie.set('test', 'hello world', expires);
 *
 *      cookie.get('test');
 *
 *      cookie.delete('test');
 *
 * expires 문자열 형식 : {숫자}{단위}
 *      - 숫자: 정수
 *      - 단위:
 *          - Y: years
 *          - M: months
 *          - D: days
 *          - h: hours
 *          - m: months
 *          - s: seconds
 *          - w: weeks
 *
 */
export class CookieUtil {
    _expiresToDate(expires) {
        const reg = /^(?<value>\d+)(?<unit>[YMDhmsw])$/g;
        let now = moment();

        const getDefault = () => {
            const d = moment();
            return d.add(1, 'hours');
        }

        if (typeof expires === 'number') {
            now.add(expires);
        } else if (typeof expires === 'string') {
            const result = reg.exec(expires);
            if (result) {
                const unit = result.groups.unit;
                const value = parseInt(result.groups.value);

                const unitMap = {
                    'Y': 'years',
                    'M': 'months',
                    'D': 'days',
                    'h': 'hours',
                    'm': 'minutes',
                    's': 'seconds',
                    'w': 'weeks',
                }

                now = now.add(value, unitMap[unit]);
            } else {
                now = getDefault();
            }
        } else { // 기본 1시간
            now = getDefault();
        }

        return now.toDate();
    }

    set(name, value, expires) {
        const expDate = this._expiresToDate(expires);
        document.cookie = name + '=' + value + ';expires=' + expDate.toGMTString() + ';path=/';
    }

    get(name) {
        let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return value? value[2] : null;
    }

    delete(name) {
        let date = new Date();
        document.cookie = name + "= " + "; expires=" + date.toUTCString() + "; path=/";
    }
}

export default new CookieUtil();